module.exports = __webpack_public_path__ + "img/x-red.c6d3600e.svg";